"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_NUMBER_OF_RECENT_SECTION_EVENTS = exports.CORRECT_SCORE = exports.MAX_MODULE_DURATION_SECONDS = void 0;
exports.MAX_MODULE_DURATION_SECONDS = 180;
exports.CORRECT_SCORE = 1.0;
exports.MAX_NUMBER_OF_RECENT_SECTION_EVENTS = 10;
